import React, { FC, useCallback, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Button, Card, CardBody, CardText, CardTitle, Col, Row } from 'reactstrap';
import { Loading, MaterialIcon, UserStateComponent } from '../../components';
import { ActionType, store } from '../../services';
import { useTranslation } from '../../translations';
import { useFetcher } from '../../utils';

const OAuthLogoutComponent: FC<RouteComponentProps> = ({ location, history }) => {
  const [next, setNext] = useState<string | null>(null);

  const { ts } = useTranslation();
  const logout = useCallback(
    async (force = false) => {
      const params = new URLSearchParams(location.search);

      if (force) {
        await api.logout();
      } else {
        const redirect_token = params.get('redirect_token');

        if (redirect_token) {
          await api.logout({ redirect_token });
        } else {
          await api.logout({
            access_token: params.get('access_token') ?? 'notprovided',
            client_id: params.get('client_id') ?? 'notprovided',
          });
        }
      }

      const localNext = params.get('next');

      if (localNext) {
        window.location.replace(localNext);
      } else {
        store.dispatch({
          type: ActionType.Logout,
        });
      }
    },
    [location],
  );

  const logoutFetcher = useFetcher(async () => {
    await logout();
  });

  const params = new URLSearchParams(location.search);

  if (logoutFetcher.loading) {
    return <Loading inline>{ts('logging_you_out')}</Loading>;
  }

  setNext(params.get('next'));

  if (logoutFetcher.success) {
    return (
      <Loading inline>{next ? ts('redirecting_you_next_to', next) : ts('redirecting_you')}</Loading>
    );
  }

  return (
    <UserStateComponent>
      <Row className="justify-content-center">
        <Col lg={6} xs={12}>
          <Row className="justify-content-center" id="oauthLogoutError">
            <Col xs={12}>
              <Card className="warning">
                <CardBody className="text-center">
                  <MaterialIcon large name="warning" type="warning" />
                  <CardTitle>{ts('logout_attempt')}</CardTitle>
                  <CardText>{ts('next_a_website_is', next ?? 'A website')}</CardText>
                  <CardText>
                    {ts('if_you_trust_this_website')}&nbsp;
                    {next && `${ts('you_will_then_be_redirected', next)}. `}
                    {ts('otherwise_click_cancel_to_return')}
                  </CardText>
                </CardBody>
              </Card>
            </Col>
            <Col className="mt-10" lg={6} xs={12}>
              <Button
                block
                color="danger"
                onClick={async () => {
                  await logout(true);
                }}
              >
                {ts('allow_logout')}
              </Button>
            </Col>
            <Col className="mt-10" lg={6} xs={12}>
              <Button
                block
                color="secondary"
                onClick={() => {
                  history.push('/');
                }}
                outline
              >
                {ts('common.cancel')}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </UserStateComponent>
  );
};

// Can this be removed? What is this?
const routedOAuthLogoutComponent = withRouter(OAuthLogoutComponent);
export { routedOAuthLogoutComponent as OAuthLogoutComponent };
